import apiClient from "../api";

export const getProfile = (data) => {
  return apiClient.get("/profile");
};

export const downloadKmlApi = (ip) => {
  try {
    return apiClient.get("/kml/download-kml", {
      params: {
        ip,
      },
    });
  } catch (error) {
    throw error;
  }
};

export function getConvertedImage(tiffUrl) {
  let base = process.env.REACT_APP_API_URL || "https://api.flyover.io/api/v1";
  const apiUrl = `${base}/convert-tiff?file=${encodeURIComponent(tiffUrl)}`;
  return apiUrl; // now just use it as an <img src={apiUrl} />
}
